exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-result-list{margin-bottom:0}.search-result-list .spacer{margin:0;padding:0;height:0;width:100%}.search-result-list .panel,.search-result-list .panel-body{margin-bottom:0!important}.btn-load-more{width:calc(100% - 10px);margin:5px 0 0 5px}@keyframes blink{0%{opacity:.2}20%{opacity:1}to{opacity:.2}}.search-progress span{animation-name:blink;animation-duration:1.4s;animation-iteration-count:infinite;animation-fill-mode:both}.search-progress span:nth-child(2){animation-delay:.2s}.search-progress span:nth-child(3){animation-delay:.4s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/search/views/SearchResultListView.css
// module id = 1984
// module chunks = 0